import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Key } from "react-aria";
import { Tab, TabList, Tabs } from "react-aria-components";
import { Popup } from "semantic-ui-react";

export function IconToggleTabBar({
  children,
  className,
  defaultValue,
  value,
  onChange,
}: React.PropsWithChildren<{
  className?: string;
  defaultValue?: Key;
  value?: Key;
  onChange?: (key: Key) => void;
}>) {
  return (
    <Tabs
      orientation='horizontal'
      defaultSelectedKey={defaultValue}
      onSelectionChange={onChange}
      selectedKey={value}
      className={className}
    >
      <TabList className='tw-flex tw-gap-[4px]'>{children}</TabList>
    </Tabs>
  );
}

function IconToggleTabBarTab({
  children,
  id,
  icon,
  tooltip,
  className,
  iconOnly = false,
}: React.PropsWithChildren<{
  id: Key;
  icon: IconDefinition;
  tooltip?: string;
  className?: string;
  iconOnly?: boolean;
}>) {
  return (
    <Tab id={id}>
      {({ isSelected }) => (
        <Popup
          hoverable
          position='bottom center'
          disabled={!tooltip}
          content={tooltip}
          mouseEnterDelay={500}
          on='hover'
          trigger={
            <div
              className={classNames(
                "tw-flex tw-h-[28px] tw-items-center tw-rounded-md tw-px-[10px] tw-py-[4px] tw-transition-colors tw-duration-75",
                {
                  "tw-cursor-pointer tw-px-[8px] hover:tw-bg-[#0000000e]  active:tw-bg-[#00000023] ": !isSelected,
                  "tw-select-none tw-gap-[8px] tw-bg-[#F5FBFE] tw-px-[10px] tw-text-primary tw-ring-1 tw-ring-[#BADFF6]":
                    isSelected,
                },
                className,
              )}
            >
              <FontAwesomeIcon icon={icon} />
              {isSelected && !iconOnly && children && <div className='tw-font-bold'>{children}</div>}
            </div>
          }
        />
      )}
    </Tab>
  );
}

function IconToggleTabBarUnderlineTab({
  children,
  id,
  icon,
  tooltip,
}: React.PropsWithChildren<{
  id: Key;
  icon: IconDefinition;
  tooltip?: string;
}>) {
  return (
    <Tab id={id}>
      {({ isSelected }) => (
        <Popup
          hoverable
          position='bottom center'
          disabled={!tooltip}
          content={tooltip}
          mouseEnterDelay={500}
          on='hover'
          trigger={
            <div
              className={classNames(
                "tw-group tw-flex tw-h-[34px] tw-items-center tw-gap-1 tw-px-3 tw-py-2 tw-transition-colors tw-duration-75",
                {
                  "tw-cursor-pointer tw-text-text-hint hover:tw-border-x-0 hover:tw-border-b-2 hover:tw-border-t-0 hover:tw-border-solid hover:tw-border-text-hint":
                    !isSelected,
                  "tw-select-none tw-border-x-0 tw-border-b-2 tw-border-t-0 tw-border-solid tw-border-primary tw-text-primary":
                    isSelected,
                },
              )}
            >
              <FontAwesomeIcon
                icon={icon}
                className={classNames({
                  "group-hover:-tw-mb-[2px]": !isSelected,
                  "-tw-mb-[2px]": isSelected,
                })}
              />
              {isSelected && children && <div className='tw-font-bold'>{children}</div>}
            </div>
          }
        />
      )}
    </Tab>
  );
}

IconToggleTabBar.Tab = IconToggleTabBarTab;
IconToggleTabBar.UnderlineTab = IconToggleTabBarUnderlineTab;
